import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { postData } from '../../Api';
import {
    MobileInfoBox,
    Modal,
    PanelBox,
    TextView,
    Title,
} from '../../components/Display';
import {
    Button,
    SearchBox,
} from '../../components/Form';
import {
    LeftComponents,
    RightComponents,
    Row,
} from '../../components/Layout';
import {
    TableBody,
    TableColumn,
    TableData,
    TableHeader,
    TableRow,
} from '../../components/Table';
import TaroffUsersEdit from '../users/TaroffUsersEdit';
import TaroffUsersNew from '../users/TaroffUsersNew';

export default function TaroffUsers(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const buttonCreateUserClick = () => {
        setModal(
            Modal({
                children: <TaroffUsersNew onDismiss={() => setModal(null)} />,
                onDismiss: () => setModal(null),
            })
        );
    };
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setFilterQUsername('');
        setSearchParams({});
    };
    const applyFilters = () => {
        const newSearchParams = {};
        filterQUsername && (newSearchParams['q-username'] = filterQUsername);
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    const [filterQUsername, setFilterQUsername] = useState(allProps['q-username'] || '');
    useEffect(() => {
        postData('/api/panel/page/taroff-users/table-data', {
            size: tableSize,
            page: tablePage,
            q_username: filterQUsername,
        }).then((response) => {
            setTableData(response.data);
        });
    }, [searchParams, modal, props]);
    const handlecomp5 = (row) => {
        setModal(
            Modal({
                children: <TaroffUsersEdit id={row.param_id} onDismiss={() => setModal(null)} />,
                onDismiss: () => setModal(null),
            })
        );
    };
    return (
        <PanelBox>
            <Row>
                <RightComponents>
                    <Title>مدیریت کاربران</Title>
                </RightComponents>
                <LeftComponents>
                    <Button onClick={buttonCreateUserClick} color={'secondary'}>
                        ایجاد کاربر
                    </Button>
                </LeftComponents>
            </Row>
            <RightComponents wrap={true}>
                <SearchBox onEnter={applyFilters}
                    label={'نام کاربری'}
                    value={filterQUsername}
                    onChange={setFilterQUsername}
                    width={'120px'}
                />
                <Button rightIcon={'far fa-search'} onClick={applyFilters}>
                    جستجو
                </Button>
                <Button rightIcon={'far fa-trash'} onClick={clearFilters}>
                    پاک کردن
                </Button>
            </RightComponents>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={true}>mobile</TableColumn>
                        <TableColumn mobile={false}>شناسه</TableColumn>
                        <TableColumn mobile={false}>عنوان فروشگاه کاربر</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>نام کاربری کاربر</TableColumn>
                        <TableColumn mobile={false}>ایمیل کاربر</TableColumn>
                        <TableColumn mobile={false}>شماره همراه کاربر</TableColumn>
                        <TableColumn mobile={false}>زمان درج</TableColumn>
                        <TableColumn mobile={false}> </TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={true}>
                                <MobileInfoBox />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_id}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <RightComponents>
                                    <TextView bold={true}>{row.text_taroff_shop_id_id}</TextView>
                                    <TextView>{row.text}</TextView>
                                    <TextView>{row.text_taroff_shop_id_title}</TextView>
                                </RightComponents>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_username}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_email}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_phone}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'persian-datetime-normal'}>
                                    {row.text_insert_time}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <Button
                                    onClick={() => handlecomp5(row)}
                                    color={'primary'}
                                    rightIcon={'far fa-edit'}
                                    tooltip={'ویرایش'}
                                ></Button>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
